import { COMPLETE_ORDER_FEATURE } from '../reducers/index';
import { createSelector, createFeatureSelector } from '@ngrx/store';

import * as fromCompleteOrder from '@complete-order/store/reducers';

const getCompleteOrderState =
  createFeatureSelector<fromCompleteOrder.CompleteOrderState>(
    COMPLETE_ORDER_FEATURE
  );

export const getUpfrontPaymentState = createSelector(
  getCompleteOrderState,
  (state) => state?.upfrontPayment
);

export const getUpfrontPayment = createSelector(
  getUpfrontPaymentState,
  (upfront) => upfront?.data
);

export const getUpfrontPaymentLoading = createSelector(
  getUpfrontPaymentState,
  (upfront) => upfront?.loading
);

export const getUpfrontPaymentLoaded = createSelector(
  getUpfrontPaymentState,
  (upfront) => upfront?.loaded
);
